// extracted by mini-css-extract-plugin
export var cardLayout = "_5p-1";
export var paginationContainer = "_5p-0";